import gql from 'graphql-tag'
import { splitError } from '@/helper/splitError'
import { getProvider } from '@/apollo'

const activePromotions = null
const creditIncentives = null
const volumeIncentives = null
const creditIncentiveDates = {}
const volumeIncentiveDates = {}

const ActivePromotionsModule = {
  namespaced: true,
  state: {
    activePromotions: activePromotions,
    creditIncentives: creditIncentives,
    volumeIncentives: volumeIncentives,
    creditIncentiveDates: creditIncentiveDates,
    volumeIncentiveDates: volumeIncentiveDates
  },
  getters: {
    activePromotions: state => {
      return state.activePromotions
    },
    creditIncentiveDates: (state, getters) => {
      const creditIncentivesList = getters.creditIncentives
      if (Array.isArray(creditIncentivesList)) {
        creditIncentiveDates.effectiveDate = creditIncentivesList[0].effectiveDate
        creditIncentiveDates.expirationDate = creditIncentivesList[0].expirationDate
        return creditIncentiveDates
      } else {
        return false
      }
    },
    volumeIncentiveDates: (state, getters) => {
      const volumeIncentivesList = getters.volumeIncentives
      if (Array.isArray(volumeIncentivesList)) {
        volumeIncentiveDates.effectiveDate = volumeIncentivesList[0].effectiveDate
        volumeIncentiveDates.expirationDate = volumeIncentivesList[0].expirationDate
        return volumeIncentiveDates
      } else {
        return false
      }
    },
    creditIncentiveDiscount: (state, getters) => {
      const creditIncentivesList = getters.creditIncentives
      if (Array.isArray(creditIncentivesList)) {
        if (creditIncentivesList[0].incentives[0].type === 'credit') {
          if (typeof creditIncentivesList[0].incentives[0].discount === 'number') {
            return creditIncentivesList[0]?.incentives[0].discount
          }
        }
      } else {
        return false
      }
    },
    creditIncentiveDescription: (state, getters) => {
      const creditIncentivesList = getters.creditIncentives
      if (Array.isArray(creditIncentivesList)) {
        if (typeof creditIncentivesList[0].incentiveInfoDescription === 'string') {
          return creditIncentivesList[0].incentiveInfoDescription
        }
      } else {
        return false
      }
    },
    creditIncentiveTitle: (state, getters) => {
      const creditIncentivesList = getters.creditIncentives
      if (Array.isArray(creditIncentivesList)) {
        if (typeof creditIncentivesList[0]?.incentives[0].title === 'string') {
          return creditIncentivesList[0]?.incentives[0].title
        }
      } else {
        return false
      }
    },
    volumeIncentiveAmount: (state, getters) => {
      const volumeIncentivesList = getters.volumeIncentives
      if (Array.isArray(volumeIncentivesList)) {
        if (volumeIncentivesList[0].incentives[0].type === 'volume') {
          if (typeof volumeIncentivesList[0].incentives[0].amount === 'number') {
            return volumeIncentivesList[0]?.incentives[0].amount
          }
        }
      } else {
        return false
      }
    },
    volumeIncentiveDescription: (state, getters) => {
      const volumeIncentivesList = getters.volumeIncentives
      if (Array.isArray(volumeIncentivesList)) {
        if (typeof volumeIncentivesList[0].incentiveInfoDescription === 'string') {
          return volumeIncentivesList[0].incentiveInfoDescription
        }
      } else {
        return false
      }
    },
    volumeIncentiveTitle: (state, getters) => {
      const volumeIncentivesList = getters.volumeIncentives
      if (Array.isArray(volumeIncentivesList)) {
        if (typeof volumeIncentivesList[0]?.incentives[0].title === 'string') {
          return volumeIncentivesList[0]?.incentives[0].title
        }
      } else {
        return false
      }
    },
    volumeIncentiveUnit: (state, getters) => {
      const volumeIncentivesList = getters.volumeIncentives
      if (Array.isArray(volumeIncentivesList)) {
        if (volumeIncentivesList[0].incentives[0].type === 'volume') {
          if (typeof volumeIncentivesList[0].incentives[0].unit === 'string') {
            return volumeIncentivesList[0]?.incentives[0].unit
          }
        }
      } else {
        return false
      }
    },
    creditIncentives: state => {
      if (Array.isArray(state.activePromotions) === true) {
        state.creditIncentives = []
        state.activePromotions.forEach(promotion => {
          // considering only one incentive per promotion
          if (promotion.incentives !== null) {
            if (promotion.incentives[0].type === 'credit') {
              state.creditIncentives.push(promotion)
            }
          }
        })
      }
      return state.creditIncentives
    },
    volumeIncentives: state => {
      if (Array.isArray(state.activePromotions) === true) {
        state.volumeIncentives = []
        state.activePromotions.forEach(promotion => {
          // considering only one incentive per promotion
          if (promotion.incentives !== null) {
            if (promotion.incentives[0].type === 'volume') {
              state.volumeIncentives.push(promotion)
            }
          }
        })
      }
      return state.volumeIncentives
    },
    volumeIncentivesForCurrentTariff: (state, getters, rootState) => {
      const promoIds = rootState.promotion.promoCode.promoIds
      const listVolumeIncentives = getters.volumeIncentives
      let index = 0
      if (listVolumeIncentives !== null && Array.isArray(listVolumeIncentives) === true) {
        const reducedList = []
        listVolumeIncentives.forEach(promotion => {
          let description = 'Dein Vorteil'
          if (promotion.description && promotion.description !== '') {
            description = promotion.description
          }
          reducedList[index] = {}
          reducedList[index].incentiveId = promotion.incentives[0].id
          reducedList[index].promotionId = promotion.promotionId
          reducedList[index].description = description
          reducedList[index].amount = promotion.incentives[0].amount
          reducedList[index].unit = promotion.incentives[0].unit
          reducedList[index].expirationDate = promotion.expirationDate
          reducedList[index].isPromoCode = promoIds.includes(promotion.promotionId)
          index++
        })
        return reducedList
      } else {
        return false
      }
    },
    creditIncentivesForCurrentTariff: (state, getters, rootState) => {
      const promoIds = rootState.promotion.promoCode.promoIds
      const listCreditIncentives = getters.creditIncentives
      let index = 0
      if (listCreditIncentives !== null && Array.isArray(listCreditIncentives) === true) {
        const reducedList = []
        listCreditIncentives.forEach(promotion => {
          let description = 'Dein Vorteil'
          if (promotion.description && promotion.description !== '') {
            description = promotion.description
          }
          reducedList[index] = {}
          reducedList[index].incentiveId = promotion.incentives[0].id
          reducedList[index].promotionId = promotion.promotionId
          reducedList[index].description = description
          reducedList[index].discount = promotion.incentives[0].discount
          reducedList[index].expirationDate = promotion.expirationDate
          reducedList[index].isPromoCode = promoIds.includes(promotion.promotionId)
          reducedList[index].entity = promotion.incentives[0].targetEntity
          reducedList[index].feeType = promotion.incentives[0].targetFee
          index++
        })
        return reducedList
      } else {
        return false
      }
    },
    monthlyCreditIncentivesForCurrentTariff: (state, getters, rootState) => {
      const promoIds = rootState.promotion.promoCode.promoIds
      const listCreditIncentives = getters.creditIncentives
      let index = 0
      if (listCreditIncentives !== null && Array.isArray(listCreditIncentives) === true) {
        const reducedList = []
        listCreditIncentives.forEach(promotion => {
          if (promotion.incentives !== null) {
            if (promotion.incentives[0].targetFee === 'MONTHLY_FEE') {
              let description = 'Dein Vorteil'
              if (promotion.description && promotion.description !== '') {
                description = promotion.description
              }
              reducedList[index] = {}
              reducedList[index].incentiveId = promotion.incentives[0].id
              reducedList[index].promotionId = promotion.promotionId
              reducedList[index].description = description
              reducedList[index].discount = promotion.incentives[0].discount
              reducedList[index].expirationDate = promotion.expirationDate
              reducedList[index].isPromoCode = promoIds.includes(promotion.promotionId)
              index++
            }
          }
        })
        return reducedList
      } else {
        return false
      }
    },
    addedVolumeAmount: (state, getters) => {
      const listVolumeIncentives = getters.volumeIncentives
      if (listVolumeIncentives !== null && listVolumeIncentives !== 'undefined' && Array.isArray(listVolumeIncentives) === true) {
        let sumAmount = 0
        listVolumeIncentives.forEach(promotion => {
          sumAmount += promotion.incentives[0].amount
        })
        return sumAmount
      } else {
        return 0
      }
    },
    addedCreditDiscount: (state, getters) => {
      const listCreditIncentives = getters.creditIncentives
      if (listCreditIncentives !== null && Array.isArray(listCreditIncentives) === true) {
        let sumDiscount = 0
        listCreditIncentives.forEach(promotion => {
          if (promotion.incentives !== null) {
            sumDiscount += promotion.incentives[0].discount
          }
        })
        return sumDiscount
      } else {
        return 0
      }
    }
  },
  actions: {
    async getActivePromotions ({ dispatch, commit, state, getters, rootGetters }) {
      await dispatch('initializeActivePromotions')
    },
    async initializeActivePromotions ({ dispatch, commit, state, getters, rootGetters }) {
      commit('clearMessages', {}, { root: true })
      const apolloClient = getProvider().defaultClient
      return apolloClient.query({
        query: gql`query {
          activePromotions {
            promotionId
            name
            description
            context
            incentiveInfoHeading
            incentiveInfoDescription
            promotionType
            bookingState
            effectiveDate
            expirationDate
            incentiveInfoDescription
            incentives {
              ... on CreditIncentive {
                id
                type
                discount
                description
                targetFee
                targetId
                targetEntity
                title
              }
              ... on VolumeIncentive {
                id
                type
                description
                amount
                unit
                title
              }
            }
            duration {
              amount
              unit
              formattedUnit
            }
          }
        }`,
        fetchPolicy: 'no-cache'
      }).then((response) => {
        if (response.data.activePromotions) {
          commit('SET_ACTIVE_PROMOTIONS', response.data.activePromotions)
        } else {
          commit('SET_ACTIVE_PROMOTIONS', null)
        }
      }).catch((error) => {
        splitError(error).forEach(e => commit('addError', e, { root: true }))
        throw error
      })
    }
  },
  mutations: {
    SET_ACTIVE_PROMOTIONS (state, activePromotions) {
      state.activePromotions = activePromotions
    }
  }
}

export default ActivePromotionsModule
